// extracted by mini-css-extract-plugin
var _1 = "NotificationCenter_actionsWrapper__DRydI";
var _2 = "NotificationCenter_content__tn4Sa";
var _3 = "NotificationCenter_header__WRSXr";
var _4 = "NotificationCenter_noUnread__Pb-bL";
var _5 = "NotificationCenter_notificationCount__daeFg";
var _6 = "NotificationCenter_title__WZxre";
var _7 = "NotificationCenter_wrapperFullScreen__OLmlF";
export { _1 as "actionsWrapper", _2 as "content", _3 as "header", _4 as "noUnread", _5 as "notificationCount", _6 as "title", _7 as "wrapperFullScreen" }
